"use client"
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';

const Stats = () => {
  const [totalProjects, setTotalProjects] = useState(0);
  const [clients, setClients] = useState(0);
  const [experience, setExperience] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const animateCount = (setState, target) => {
            let count = 0;
            const duration = 1000;
            const stepTime = Math.max(Math.floor(duration / target), 25);
            const interval = setInterval(() => {
              count++;
              setState(count);
              if (count >= target) clearInterval(interval);
            }, stepTime);
          };

          animateCount(setTotalProjects, 100);
          animateCount(setClients, 180);
          animateCount(setExperience, 200);

          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" ref={sectionRef}>
      {/* Card 1 */}
      <div className="bg-white px-2 py-4 shadow-sm test">
        <div className="flex items-center space-x-3 mb-3">
          <div className="w-10 h-10 bg-[#4c0c3e] rounded-full flex items-center justify-center">
            <Image src='/icons/certificate-badge.svg' height={6} width={6} alt='icon' className='w-6 h-6 text-white' placeholder='blur' blurDataURL="/svg-placeholder.jpg" />
          </div>
          <span className="text-3xl font-bold text-[#4c0c3e]">{totalProjects}+</span>
        </div>
        <p className="text-gray-600 font-medium">Successful Odoo Implementations</p>
      </div>

      {/* Card 2 */}
      <div className="bg-white rounded-2xl px-2 py-4 shadow-sm test">
        <div className="flex items-center space-x-3 mb-3">
          <div className="w-10 h-10 bg-[#4c0c3e] rounded-full flex items-center justify-center">
            <Image src='/icons/certified-person.svg' height={6} width={6} alt='icon' className='w-6 h-6 text-white' placeholder='blur' blurDataURL="/svg-placeholder.jpg" />
          </div>
          <span className="text-3xl font-bold text-[#4c0c3e]">{clients}+</span>
        </div>
        <p className="text-gray-600 font-medium">In-House <span className='text-[#4c0c3e]'>Developers</span> & <span className='text-[#4c0c3e]'>Consultants</span></p>
      </div>

      {/* Card 3 */}
      <div className="bg-white rounded-2xl px-2 py-4 shadow-sm test">
        <div className="flex items-center space-x-3 mb-3">
          <div className="w-10 h-10 bg-[#4c0c3e] rounded-full flex items-center justify-center">
            <Image src='/icons/people-group.svg' height={6} width={6} alt='icon' className='w-6 h-6 text-white' placeholder='blur' blurDataURL="/svg-placeholder.jpg" />
          </div>
          <span className="text-3xl font-bold text-[#4c0c3e]">{experience}+</span>
        </div>
        <p className="text-gray-600 font-medium"><span className='text-[#4c0c3e]'>Clients</span> Across 20+ <span className='text-[#4c0c3e]'>Industries</span></p>
      </div>
    </div>

  );
};

export default Stats;